import { render, staticRenderFns } from "./TotalAdditionalBenefits.vue?vue&type=template&id=1b10d662&scoped=true&"
import script from "./TotalAdditionalBenefits.vue?vue&type=script&lang=js&"
export * from "./TotalAdditionalBenefits.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/customerHome.css?vue&type=style&index=0&id=1b10d662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10d662",
  null
  
)

export default component.exports